<template>
    <el-container class="home-container">
        <el-aside width="260px">
            <el-menu default-active="2" background-color="#020e24" text-color="#ecedee" active-text-color="#c7401d" unique-opened router  style="height: 100%;">
                <el-menu-item>
                    <div class="logo-container">
                        <img src="@/assets/image/logo22.png" alt="Logo" class="menu-logo-large">
                    </div>
                </el-menu-item>
                <el-menu-item>
                    <!-- <div style="color:#c7401d;font-weight: bold;padding-left:20px">共享健身后台管理系统</div> -->
                    <div class="system-title">共享健身后台管理系统</div>
                </el-menu-item>
                <el-submenu index="0">
                    <template slot="title">
                    <i class="el-icon-s-data"></i>
                    <span>财务统计</span>
                    </template>
                    <el-menu-item index="/joinwelcome" @click="saveNavState('/joinwelcome')"><i class="el-icon-menu"></i>财务统计数据</el-menu-item>
                </el-submenu>
                <el-submenu index="1">
                    <template slot="title">
                    <i class="el-icon-postcard"></i>
                    <span>会员卡管理</span>
                    </template>
                    <el-menu-item index="/storecard"  @click="saveNavState('/storecard')"><i class="el-icon-menu"></i>会员卡设置</el-menu-item>
                </el-submenu>
                <el-submenu index="2">
                    <template slot="title">
                    <i class="el-icon-user"></i>
                    <span>会员管理</span>
                    </template>
                    <el-menu-item index="/storeusers"  @click="saveNavState('/storeusers')"><i class="el-icon-menu"></i>会员列表</el-menu-item>
                </el-submenu>
                <el-submenu index="3">
                    <template slot="title">
                    <i class="el-icon-s-order"></i>
                    <span>订单管理</span>
                    </template>
                    <el-menu-item index="/storeorder"  @click="saveNavState('/storeorder')"><i class="el-icon-menu"></i>订单列表</el-menu-item>
                </el-submenu>
                <el-submenu index="4">
                    <template slot="title">
                    <i class="el-icon-s-order"></i>
                    <span>助教提现</span>
                    </template>
                    <el-menu-item index="/coachTx"  @click="saveNavState('/coachTx')"><i class="el-icon-menu"></i>提现记录</el-menu-item>
                </el-submenu>
                <!-- <el-submenu index="4">
                    <template slot="title">
                    <i class="el-icon-s-promotion"></i>
                    <span>拓客管理</span>
                    </template>
                    <el-menu-item index="/storediffer"  @click="saveNavState('/storediffer')"><i class="el-icon-menu"></i>异业合作</el-menu-item>
                </el-submenu> -->
            </el-menu>
        </el-aside>
        <el-container>
            <el-header>
                <div style="padding-left: 20px;color:#c7401d">
                    <!-- <i class="el-icon-message-solid"></i><span style="padding-left: 10px;">下面发布一则通知.....</span> -->
                    <!-- <el-button type="primary" icon="el-icon-search">搜索</el-button>
                    <i class="el-icon-search" color="#ff0000"></i>
                    <span style="font-size:25px;color:#c7401d;padding-left:20px">共享健身后台管理系统--{{name_token}}</span> -->
                </div>
                <div class="header-user-info">
                    <span class="user-name">你好，{{name_token}}</span>
                    <el-button @click="editDialogVisible = true">修改密码</el-button>
                    <el-button type="" @click="LogOut">退出</el-button>
                </div>
            </el-header>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
        <!--修改密码对话框-->
        <el-dialog title="修改密码" :visible.sync="editDialogVisible" width="40%">
            <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
                <el-form-item label="原密码" prop="password">
                    <el-input v-model="editForm.password" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="new_password">
                    <el-input v-model="editForm.new_password" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="con_password">
                    <el-input v-model="editForm.con_password" show-password></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editPass">确 定</el-button>
            </span>
        </el-dialog>
        <!--修改密码对话框-->
    </el-container>
</template>
<script>
export default {
    data(){
        //验证原密码规则
        // var oldPass = (rule, value, callback) => {
        //     if (value !== this.old_password) {
        //     callback(new Error('原密码不正确!'));
        //     } else {
        //     callback();
        //     }
        // }
        //验证确认密码规则
        var validatePass = (rule, value, callback) => {
            if (value !== this.editForm.new_password) {
            callback(new Error('两次输入密码不一致!'));
            } else {
            callback();
            }
        }
        return {
            isCollapse: false,
            activePath: '',
            editDialogVisible:false,
            old_password:'',
            editForm:{
                 password:'',
                 new_password:'',
                 con_password:''
            },
            editFormRules: {
                password: [
                    { required: true, message: '请输入原密码', trigger: 'blur' },
                ],
                new_password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                ],
                con_password: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ]
            },
            name_token:'',
            id_token:'',
            pass_token:'',
            login_token:'',
            join_token:''
        }
    },
    created(){
        this.name_token = window.sessionStorage.getItem('join_name_token')
        this.id_token = window.sessionStorage.getItem('join_id_token')
        this.pass_token = window.sessionStorage.getItem('join_pass_token')
        this.login_token = window.sessionStorage.getItem('join_login_token')
        this.join_token = window.sessionStorage.getItem('join_token')
        console.log('name_token',this.name_token)
        console.log('id_token',this.id_token)
        console.log('pass_token',this.pass_token)
        console.log('login_token',this.login_token)
        console.log('join_token',this.join_token)
        this.activePath = window.sessionStorage.getItem('activePath') || ''
    },
    methods:{
        saveNavState(path) {
            window.sessionStorage.setItem('activePath', path);
            this.activePath = path;
        },
        LogOut(){
            window.sessionStorage.clear()
            this.$router.push('/joinlogin')
        },
        editPass(){
            this.$refs.editFormRef.validate(async valid => {
                if(!valid) return
                const {data:res} = await this.$http.post('/joinadmin/password',{id:this.id_token,old_password:this.editForm.password,new_password:this.editForm.new_password})
                if(res.status !== 0) return this.$message.error('修改失败！')
                this.$message.success('修改成功！')
                this.editDialogVisible = false
                window.sessionStorage.setItem('join_pass_token',this.editForm.new_password)
            })
        }
    }
}
</script>
<style>
    .home-container{
        padding-top:0px;
        height: 100%;
    }
    .el-header{
        background-color: #ffffff;
        display: flex;
        justify-content: space-between;
        padding-left: 100px;
        align-items: center;
        font-size: 20px;
        color: #fff;
        height: 60px !important;
    }
    .el-aside{
	    background-color: #020e24;
    }
    .el-main {
        background-color:#FAFAFA;
    }
    .el-menu {
		border-right: none;
    }
    .el-submenu :hover{
        background-color: #fef4b6 !important;
    }
    .el-submenu__title,.el-dropdown-menu__item, .el-menu-item{
        font-size: 16px !important;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center;     /* 垂直居中 */
        padding:0;
    }
    .el-submenu__title i{
        color:#ecedee !important;
    }

    /* 添加logo相关样式 */
    .logo-container {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        height:100%;
        margin: 10px 0;
        width: 80%;
        padding: 5px 0;
    }

    .menu-logo-large {
        width: 80%;
        height: auto;
        margin: 0;
        object-fit: contain;
    }

    /* 添加右上角用户名样式 */
    .header-user-info {
        display: flex;
        align-items: center;
    }

    .user-name {
        margin-right: 15px;
        font-size: 14px;
        color: #333;
        font-weight: bold;
    }
    /* 系统名称样式 */
    .system-title {
        color: #ffffff;
        display: flex;
        justify-content: flex-start;
        font-weight: bold;
        padding-left:0px;
        margin-left:-35px !important;
        margin:20px 0; /* 增加上下间距，区分模块 */
        line-height: normal;
        font-size:20px; /* 新增，让文字垂直居中，根据实际需求调整数值 */
    }
</style>
